import { Form, Image, Input, TreeSelect, Modal, Button, Space, InputNumber, Radio } from "antd";
import { useEffect, useState } from "react";
import UploadComponent from "../../components/UploadComponent";
import { SearchOutlined } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";
import { useGlobalState } from "../../components/global";

export default function MenuForm({ form, item, menuList }: any) {
    const { jsonRequest } = useGlobalState();
    const [fileList, setFileList]: any = useState([]);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [data, setData] = useState<any>([]);
    const [iconModalVisible, setIconModalVisible] = useState(false);
    const [iconList, setIconList] = useState<any[]>([]);
    const [filteredIconList, setFilteredIconList] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState("");
    const [selectedIcon, setSelectedIcon] = useState<string | null>(null);

    const handleDropdownVisibleChange = (visible: boolean) => {
        setDropdownVisible(visible);
    };

    const init = async (url: any) => {
        const result = await jsonRequest.get(`/common/oss-file-visit-url`, { fileUrl: url })
            .then((resp: any) => resp.json());
        return result?.data;
    };

    const handleUploadSuccess = async (fileList: any) => {
        const url = await init(fileList[fileList.length - 1].url);
        setFileList([{ url: url }]);
        form.setFieldValue("icon", fileList[fileList.length - 1].url);
        setSelectedIcon(null);
    }

    const handleCheck = (value: any) => {
        setCheckedKeys(value);
    };

    // 遍历将数据转换为树形结构
    function transfromData(data: any) {
        return data.map((item: any) => {
            const { menuName, id, children } = item;
            const res = {
                label: menuName,
                value: id || menuName,
                key: id || menuName,
                children: []
            };
            if (children && children.length) {
                res.children = transfromData(children);
            }
            return res;
        });
    }

    const getData = (menu: any) => {
        const result = [{ label: '暂无上级菜单', value: 0, key: 0, children: [] }, ...transfromData(menu)];
        setData(result);
    };

    // 初始化图标列表
    useEffect(() => {
        const icons = Object.keys(Icons)
            .filter(key => {
                const IconComponent = Icons[key as keyof typeof Icons];
                return typeof IconComponent === 'object' && IconComponent !== null;
            })
            .map(key => ({
                name: key,
                component: Icons[key as keyof typeof Icons]
            }));
        setIconList(icons);
        setFilteredIconList(icons);
    }, []);

    // 搜索图标
    const handleSearchIcon = (value: string) => {
        setSearchValue(value);
        if (!value) {
            setFilteredIconList(iconList);
        } else {
            const filtered = iconList.filter(icon =>
                icon.name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredIconList(filtered);
        }
    };

    // 选择图标
    const handleSelectIcon = (iconName: string) => {
        form.setFieldValue("icon", iconName);
        // 清除上传的图标
        setFileList([]);
        setIconModalVisible(false);
        setSelectedIcon(iconName);
    };

    // 渲染图标
    const renderIcon = (iconName: string) => {
        const IconComponent = Icons[iconName as keyof typeof Icons] as any;
        return IconComponent ? <IconComponent /> : null;
    };

    useEffect(() => {
        getData(menuList);
        if (item?.id) {
            setFileList([{ url: item?.url }]);
            form.setFieldsValue(item);
            if (item.type === 'antd') {
                setSelectedIcon(item.icon);
            }
        }
    }, []);

    return (
        <Form form={form} size="small" name="menu" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} autoComplete="off">
            <Form.Item label="上级菜单" name="parentId" rules={[{ required: true, message: '不能为空' }]}>
                <TreeSelect
                    treeData={data}
                    allowClear
                    placeholder="请选择上级菜单"
                    value={checkedKeys}
                    onSelect={(value) => handleCheck(value)}
                    open={dropdownVisible}
                    onDropdownVisibleChange={handleDropdownVisibleChange}
                />
            </Form.Item>
            <Form.Item label="菜单名称" name="menuName" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入菜单名称" />
            </Form.Item>
            <Form.Item label="路由地址" name="path" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入路由地址" />
            </Form.Item>
            <Form.Item label="组件路由" name="component">
                <Input placeholder="请输入组件路由" />
            </Form.Item>
            <Form.Item label="路由参数" name="query">
                <Input placeholder="请输入路由参数" />
            </Form.Item>
            <Form.Item label="路由名称" name="routeName">
                <Input placeholder="请输入路由名称" />
            </Form.Item>
            <Form.Item label="菜单图标">
                <Space align="start">
                    {(selectedIcon || (fileList && fileList.length > 0)) && (
                        <div>
                            {selectedIcon ? (
                                <Button
                                    style={{
                                        fontSize: '24px',
                                        width: 50,
                                        height: 50,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {renderIcon(selectedIcon)}
                                </Button>
                            ) : (
                                <Image
                                    src={fileList[0]?.url}
                                    preview={false}
                                    width={50}
                                    height={50}
                                    style={{ objectFit: 'contain' }}
                                />
                            )}
                        </div>
                    )}
                    <Space>
                        <Button onClick={() => setIconModalVisible(true)}>
                            选择图标
                        </Button>
                        <span>或</span>
                        <UploadComponent
                            value={fileList}
                            showUploadList={false}
                            type="picture"
                            onChange={(fileList: any) => handleUploadSuccess(fileList)}
                            children={<Button>上传图标</Button>}
                        />
                    </Space>
                </Space>
            </Form.Item>
            <Form.Item label="是否隐藏" name="hiddenFlag" rules={[{ required: true, message: '不能为空' }]} initialValue={false}>
                <Radio.Group>
                    <Radio value={true}>是</Radio>
                    <Radio value={false}>否</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item label="排序号" name="sortNum">
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="备注" name="remark">
                <Input.TextArea placeholder="请输入备注信息" autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="图标地址" name="icon" hidden>
                <Input />
            </Form.Item>
            <Modal
                title="选择图标"
                open={iconModalVisible}
                onCancel={() => setIconModalVisible(false)}
                footer={null}
                width={800}
            >
                <Input
                    placeholder="搜索图标..."
                    prefix={<SearchOutlined />}
                    value={searchValue}
                    onChange={(e) => handleSearchIcon(e.target.value)}
                    style={{ marginBottom: 16 }}
                />
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: 16,
                    maxHeight: 400,
                    overflowY: 'auto'
                }}>
                    {filteredIconList.map((icon) => {
                        const IconComponent = icon.component as any;
                        return (
                            <div
                                key={icon.name}
                                onClick={() => handleSelectIcon(icon.name)}
                                style={{
                                    textAlign: 'center',
                                    padding: 8,
                                    cursor: 'pointer',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: 4,
                                    transition: 'all 0.3s',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#1890ff';
                                    e.currentTarget.style.backgroundColor = '#f0f7ff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#d9d9d9';
                                    e.currentTarget.style.backgroundColor = '#fff';
                                }}
                            >
                                <div style={{ fontSize: 24, display: 'flex', justifyContent: 'center' }}>
                                    {IconComponent && <IconComponent />}
                                </div>
                                <div style={{
                                    fontSize: 12,
                                    marginTop: 4,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {icon.name}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Modal>
        </Form>
    )
}